<template>
    <div>
        <div
            @mouseleave="categoryTabs = false"
            @mouseenter="categoryTabs = true"
        >
            <CategoryTabs
                :status="categoryTabs"
                @filterByCategory="fetchFilteredProductsByCategoryOnly"
            />
            <!-- @filterByWholesaler="fetchFilteredProductsByWholesalerOnly" -->
        </div>

        <div class="container p-4 mx-auto md:px-1 md:py-4">
            <!-- Banner -->
            <div
                v-if="!isWholesaler"
                class="hidden w-full lg:flex md:space-x-4 lg:space-x-6"
                :class="currentlyFilteredCategoryBannerPath() ? 'mb-12 h-72' : ''"
            >
                <!-- <div
                    v-if="currentlyFilteredCategoryBannerPath()"
                    class="relative flex-grow overflow-hidden rounded"
                >
                    <div class="absolute inset-0 flex items-end justify-start text-3xl font-bold">
                        <div class="p-4 text-white bg-green-600 opacity-80 rounded-tr-xl">
                            {{ currentlyFilteredCategoryBannerPath().name }}
                        </div>
                    </div>
                    <img
                        :src="currentlyFilteredCategoryBannerPath().banner_path"
                        alt="Image"
                        class="w-full h-full"
                    >
                </div> -->
                <!-- move else attribute to the below div if the above banner is ever uncommented -->
                <!-- v-else -->
                <div class="relative flex-grow overflow-hidden rounded">
                    <Carousel
                        :navigation-enabled="true"
                        :per-page="1"
                        :autoplay="true"
                        :autoplay-timeout="10000"
                        :autoplay-hover-pause="true"
                        :loop="true"
                    >
                        <Slide
                            v-for="featuredImage in productFeaturedImages"
                            :key="'product-featured-image-' + featuredImage.id"
                        >
                            <div class="relative h-72">
                                <div class="absolute inset-0 flex items-end justify-start text-3xl font-bold">
                                    <div class="p-4 text-white bg-green-600 opacity-80 rounded-tr-xl">
                                        {{ featuredImage.title }}
                                    </div>
                                </div>
                                <img
                                    :src="featuredImage.image_path"
                                    alt="Image"
                                    class="w-full h-full"
                                />
                            </div>
                        </Slide>
                    </Carousel>
                </div>
            </div>

            <!-- content` -->
            <div class="relative flex py-5">
                <!-- filters -->
                <div class="hidden">
                    <ProductFilters
                        ref="filters"
                        :products="products.data"
                        :wholesalers="wholesalers"
                        :categories="categories"
                        :brands="brands"
                        :applied-filters="appliedFilters"
                        :sort-by="sortedBy"
                        class="hidden w-60 md:block"
                    />
                </div>

                <!-- Filter for small screen  -->
                <!-- <div
                    class="fixed inset-0 z-30 overflow-y-auto duration-300 ease-out transform bg-white"
                    :class="isFilterOpen ? 'translate-y-0' : 'translate-y-full'"
                >
                    <div class="flex items-center justify-between h-12 px-3 py-2 shadow">
                        <p>Filter</p>
                        <div @click="isFilterOpen = false">
                            <CloseIcon class="w-6 fill-current" />
                        </div>
                    </div>

                    <div class="px-3 py-2">
                        <ProductFilters
                            :products="products.data"
                            :wholesalers="wholesalers"
                            :categories="categories"
                            :brands="brands"
                            :applied-filters="appliedFilters"
                            :sort-by="sortedBy"
                        />
                    </div>
                </div> -->

                <!-- Content -->
                <div class="flex-grow max-w-full">
                    <!-- Top part to keep search filters add button and stuff -->
                    <div class="flex flex-col justify-between space-y-2 lg:space-y-0 md:flex-row lg:items-center">
                        <div
                            v-if="appliedFilters.categoryIds || appliedFilters.brandIds || appliedFilters.wholesalerIds"
                            class="flex flex-col w-full space-y-2 lg:space-y-0 lg:flex-row"
                        >
                            <h2 class="text-xl font-bold md:text-2xl mb-10">Products</h2>

                            <!-- Commented the code to searchthe product for the applied wholesaler -->
                            <!-- <div class="relative flex-grow lg:px-4 ">
                                <input
                                    v-model="search"
                                    class="w-full h-10 px-3 py-2 pl-8 text-sm border border-gray-300 rounded-lg bg-gray-50 focus:bg-gray-100 focus:outline-none focus:shadow-outline"
                                    placeholder="Search..."
                                    @keydown.enter="getSearchResultsFor"
                                >
                                <div class="absolute top-0 flex items-center h-full ml-2">
                                    <SearchIcon
                                        :key="'retailerViewSearchIcon'"
                                        class="w-4 text-gray-400 fill-current"
                                    />
                                </div>
                                <div
                                    class="absolute flex items-center justify-center w-8 h-full top-1 right-5 "
                                    @click="getSearchResultsFor"
                                >
                                    &#x23CE;
                                </div>
                            </div> -->
                        </div>

                        <div
                            class="flex flex-col justify-end w-full space-y-2 lg:space-y-0 lg:items-center md:flex-row md:flex-grow md:space-x-8"
                        >
                            <!-- price slider -->
                            <div
                                v-if="
                                    appliedFilters.categoryIds ||
                                    appliedFilters.brandIds ||
                                    appliedFilters.wholesalerIds
                                "
                                class="flex flex-col md:flex-row md:items-center"
                            >
                                <div class="font-semibold w-36 pb-2">Price Range</div>
                                <div class="w-full md:w-52">
                                    <t-select
                                        ref="priceRange"
                                        placeholder="Price Range"
                                        :options="['All', '0-5', '5-10', '10-20', '20-50', '50-100', 'Above 100']"
                                        @input="setPriceRange"
                                    />
                                </div>
                            </div>

                            <!-- Condition -->
                            <!-- <div class="w-full md:w-52">
                                <t-select
                                    v-model="productFilterStatus"
                                    placeholder="Product Status"
                                    :options="[
                                        { text: 'New', value: 'New' },
                                        { text: 'Used', value: 'Used' },
                                        { text: 'Refurbished', value: 'Refurbished' },
                                    ]"
                                />
                            </div> -->

                            <!-- Brands -->
                            <!-- <div class="w-full md:w-52">
                                <t-select
                                    v-model="productFilterBrandId"
                                    placeholder="Product Brand"
                                    :options="brandsListForSelect"
                                />
                            </div> -->

                            <!-- Sort By -->
                            <!-- v-if="!isFilteredByParentCategory || appliedFilters.brandIds || appliedFilters.wholesalerIds" -->
                            <div
                                v-if="
                                    appliedFilters.categoryIds ||
                                    appliedFilters.brandIds ||
                                    appliedFilters.wholesalerIds
                                "
                                class="w-full md:w-52"
                            >
                                <t-select
                                    v-model="sortedBy"
                                    placeholder="Sort By"
                                    :options="[
                                        { text: 'Popularity', value: 'popularity' },
                                        { text: 'Price: High to Low', value: 'desc-price' },
                                        { text: 'Price: Low to High', value: 'asc-price' },
                                        { text: 'Sold Items: High to Low', value: 'desc-sold' },
                                        { text: 'Sold Items: Low to High', value: 'asc-sold' },
                                        { text: 'Stock: High to Low', value: 'desc-stock' },
                                        { text: 'Stock: Low to High', value: 'asc-stock' },
                                    ]"
                                />
                            </div>

                            <div
                                class="px-5 py-2.5 flex-shrink-0 text-center lg:ml-4 text-sm border rounded md:hidden cursor-pointer bg-white"
                                @click="isFilterOpen = true"
                            >
                                Filters
                            </div>
                        </div>
                    </div>

                    <!-- Filter tags  -->
                    <!-- <div
                        v-if="filters.length"
                        class="my-4"
                    >
                        <div
                            v-for="(tag, index) in filters"
                            :key="index"
                            class="inline-block px-2 py-1 m-1 text-xs border border-gray-300 rounded-full"
                        >
                            <div class="flex justify-around">
                                <p>{{ tag.name }}</p>
                                <span
                                    class="px-1 ml-2 font-semibold rounded-full cursor-pointer hover:bg-gray-300"
                                    @click="clearTag(tag)"
                                >
                                    X
                                </span>
                            </div>
                        </div>
                        <div
                            v-if="filters.length > 1"
                            class="inline-block px-2 py-1 m-1 text-xs border border-gray-300 rounded-full cursor-pointer hover:bg-gray-300"
                            @click="clearAll"
                        >
                            <div class="flex justify-around">
                                <p>Clear All</p>
                                <span class="px-1 ml-1 font-semibold rounded-full ">X</span>
                            </div>
                        </div>
                    </div> -->

                    <div v-if="isSearchPage && products.data.length">
                        Search results for keyword '<b>{{ appliedFilters.keyword }}</b
                        >'.
                    </div>

                    <div v-if="isSearchPage && !products.data.length">
                        No results found for keyword '<b>{{ appliedFilters.keyword }}</b
                        >'.
                    </div>

                    <!-- Card content to list the Products -->
                    <!-- <div v-if="!isFilteredByParentCategory || appliedFilters.brandIds || appliedFilters.wholesalerIds"> -->
                    <div
                        v-if="
                            appliedFilters.keyword ||
                            appliedFilters.categoryIds ||
                            appliedFilters.brandIds ||
                            appliedFilters.wholesalerIds
                        "
                    >
                        <div
                            v-if="products.data.length"
                            class="grid grid-cols-1 gap-4 my-6 divide-x md:gap-6 md:grid-cols-2 lg:grid-cols-4"
                            :class="{ 'grid-cols-1 md:grid-cols-2 lg:grid-cols-5': !appliedFilters.categoryIds }"
                        >
                            <ProductCard
                                v-for="(product, index) in products.data"
                                :key="'new-products-' + index"
                                :product="product"
                            />
                        </div>

                        <div v-else-if="!isSearchPage">No Product Found.</div>

                        <div
                            v-if="products.data.length > perPage"
                            class="flex justify-center items-center bg-gray-100 dark:bg-gray-800 px-4 py-4 border-t dark:border-gray-700"
                        >
                            <t-pagination
                                v-model="currentPage"
                                variant="rounded"
                                :total-items="totalRows"
                                :per-page="perPage"
                                :limit="limit"
                                :disabled="disabled"
                                @change="fetchFilteredProducts"
                            />
                        </div>
                    </div>

                    <!-- sub categories -->
                    <section
                        v-if="categoriesForShopByCategory().length"
                        class="py-8 bg-gray-50"
                    >
                        <div class="mx-auto px-0">
                            <h2 class="text-xl font-bold md:text-2xl mb-10">Shop by Category</h2>
                            <swiper
                                :options="categorySwiperOptions"
                                class="pb-6"
                            >
                                <swiper-slide
                                    v-for="category in categoriesForShopByCategory()"
                                    :key="'category-' + category.id"
                                >
                                    <div class="flex flex-col items-center justify-center p-2">
                                        <div class="mb-4">
                                            <img
                                                :src="
                                                    category.images.length
                                                        ? category.images[0].image_path
                                                        : `https://ui-avatars.com/api/?name=${category.name}&color=7F9CF5&background=EBF4FF`
                                                "
                                                class="p-1 rounded-full cursor-pointer h-14 w-14 md:w-28 md:h-28 ring"
                                                @click="fetchFilteredProductsByCategory(category.id)"
                                            />
                                        </div>
                                        <div class="text-center">
                                            {{ category.name }}
                                        </div>
                                    </div>
                                </swiper-slide>
                                <swiper-slide>
                                    <div class="flex flex-col items-center justify-center p-2">
                                        <div
                                            class="flex items-center justify-center rounded-full cursor-pointer h-14 w-14 md:w-28 md:h-28 ring"
                                            @click="goto('categories.index')"
                                        >
                                            <div class="text-center text-sm sm:text-md">View More</div>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                        </div>
                    </section>

                    <!-- category brands -->
                    <section
                        v-if="brandsForShopByBrand().length"
                        class="py-8 bg-gray-50"
                    >
                        <div class="mx-auto px-0">
                            <h2 class="text-xl font-bold md:text-2xl mb-10">Shop by Brand</h2>
                            <swiper
                                :options="brandSwiperOptions"
                                class="pb-6"
                            >
                                <swiper-slide
                                    v-for="brand in brandsForShopByBrand()"
                                    :key="'brand-' + brand.id"
                                >
                                    <div class="flex flex-col items-center justify-center p-2">
                                        <div class="mb-4">
                                            <img
                                                :src="
                                                    brand.images.length
                                                        ? brand.images[0].image_path
                                                        : `https://ui-avatars.com/api/?name=${brand.name}&color=7F9CF5&background=EBF4FF`
                                                "
                                                class="p-1 rounded-full cursor-pointer h-14 w-14 md:w-28 md:h-28 ring"
                                                @click="fetchFilteredProductsByBrand(brand.id)"
                                            />
                                        </div>
                                        <div>
                                            {{ brand.name }}
                                        </div>
                                    </div>
                                </swiper-slide>
                                <swiper-slide>
                                    <div class="flex flex-col items-center justify-center p-2">
                                        <div
                                            class="flex items-center justify-center rounded-full cursor-pointer h-14 w-14 md:w-28 md:h-28 ring"
                                            @click="goto('brands.index')"
                                        >
                                            <div class="text-center text-sm sm:text-md">View More</div>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                        </div>
                    </section>

                    <!-- shop by deal -->
                    <section
                        v-if="productsForShopByDeal().length"
                        class="py-8 bg-gray-50"
                    >
                        <div class="mx-auto px-0">
                            <!-- sub categories -->
                            <h2 class="text-xl font-bold md:text-2xl mb-10">Shop by Deal</h2>
                            <swiper
                                :options="recentProductsSwiperOptions"
                                class="pb-6"
                            >
                                <swiper-slide
                                    v-for="(product, index) in productsForShopByDeal()"
                                    :key="'new-products-' + index"
                                >
                                    <ProductCard :product="product" />
                                </swiper-slide>
                            </swiper>
                        </div>
                    </section>

                    <!-- Recently Added -->
                    <section
                        v-if="recentlyAddedProducts.length"
                        class="py-8 bg-gray-50"
                    >
                        <div class="mx-auto px-0">
                            <!-- sub categories -->
                            <h2 class="text-xl font-bold md:text-2xl mb-10">Recently Added</h2>
                            <swiper
                                ref="swiperRecentProductRef"
                                :options="productsSwiperOptions"
                                class="pb-6"
                                @ready="onSwiperReady('swiperRecentProductRef', $event)"
                                @mouseenter.native="pauseAutoplay('swiperRecentProductRef')"
                                @mouseleave.native="resumeAutoplay('swiperRecentProductRef')"
                            >
                                <swiper-slide
                                    v-for="(product, index) in recentlyAddedProducts"
                                    :key="'new-products-' + index"
                                >
                                    <ProductCard :product="product" />
                                </swiper-slide>
                            </swiper>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
    import 'swiper/css/swiper.css';
    import 'vue-range-component/dist/vue-range-slider.css';
    import _ from 'lodash';
    import ProductFilters from '../../Components/ProductFilters.vue';
    import ProductCard from '../../Components/ProductCard.vue';
    import CategoryTabs from '../../Components/CategoryTabs.vue';
    import common from '../../common';

    export default {
        name: 'ProductsRetailerView',

        components: {
            ProductFilters,
            ProductCard,
            Swiper,
            SwiperSlide,
            // CloseIcon,
            CategoryTabs,
            Carousel,
            Slide,
            // SearchIcon,
            // VueRangeSlider,
        },

        metaInfo() {
            return {
                title: 'B2B Shopping',
                titleTemplate: 'Humtt - %s',
            };
        },

        props: {
            products: {
                type: Object,
                required: true,
            },
            recentlyAddedProducts: {
                type: Array,
                default: () => [],
            },
            productFeaturedImages: {
                type: Array,
                default: () => [],
            },
            wholesalers: {
                type: Array,
                required: true,
            },
            categories: {
                type: Array,
                required: true,
            },
            brands: {
                type: Array,
                required: true,
            },
            appliedFilters: {
                type: Object,
                required: true,
            },
            sortBy: {
                validator: (prop) => typeof prop === 'string' || prop === null,
                required: true,
            },
        },

        data() {
            return {
                common,
                isFilterOpen: false,
                mounted: false,
                priceRange: [common.minPrice, common.maxPrice],
                productFilterStatus: null,
                productFilterBrandId: null,
                sortedBy: null,
                currentPage: null,
                limit: 5,
                perPage: this.products.per_page,
                totalRows: this.products.total,
                categoryTabs: true,
                isFilteredByParentCategory: false,
                bgStyle: {
                    backgroundColor: '#fff',
                    boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)',
                },
                tooltipStyle: {
                    backgroundColor: '#047857',
                    borderColor: '#047857',
                },
                processStyle: {
                    backgroundColor: '#10B981',
                },
                min: common.minPrice,
                max: common.maxPrice,
                search: null,
                swiperOptions: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    loop: true,
                    autoplay: {
                        delay: 3000,
                        disableOnInteration: false,
                    },
                    pagination: false,
                    navigation: false,
                    breakpoints: {
                        320: { slidesPerView: 2 },
                        425: { slidesPerView: 3 },
                        640: { slidesPerView: 4 },
                        // 768: { slidesPerView: 4 },
                        1024: { slidesPerView: 6 },
                    },
                },
            };
        },

        computed: {
            disabled() {
                return !this.products.data.length;
            },

            categorySwiperOptions() {
                return this.defaultSwiperOptions;
            },

            brandSwiperOptions() {
                return this.defaultSwiperOptions;
            },

            productsSwiperOptions() {
                return {
                    ...this.defaultSwiperOptions,
                    spaceBetween: 20,
                    autoplay: {
                        ...this.defaultSwiperOptions.autoplay,
                        delay: 2000,
                    },
                };
            },

            recentProductsSwiperOptions() {
                return {
                    ...this.defaultSwiperOptions,
                    spaceBetween: 20,
                    autoplay: {
                        ...this.defaultSwiperOptions.autoplay,
                        delay: 2000,
                    },
                };
            },

            brandsListForSelect() {
                return this.brands.map((brand) => ({
                    text: brand.name,
                    value: brand.id,
                }));
            },

            noFiltersApplied() {
                let filtersApplied = false;
                this.appliedFilters.forEach((filter) => {
                    if (filter != null) {
                        filtersApplied = true;
                    }
                });
                return filtersApplied;
            },

            isSearchPage() {
                return this.$page.url.includes('/search/');
            },

            filteredCategory() {
                const cat = this.appliedFilters.categoryIds && [
                    this.categories.find((category) => category.id === parseInt(this.appliedFilters.categoryIds[0])),
                ];
                return cat != null ? cat : [];
            },

            filteredBrand() {
                const brand = this.appliedFilters.brandIds && [
                    this.brands.find((b) => b.id === parseInt(this.appliedFilters.brandIds[0])),
                ];
                return brand != null ? brand : [];
            },

            filteredWholesaler() {
                const wholesaler = this.appliedFilters.wholesalerIds && [
                    this.wholesalers.find((w) => w.id === parseInt(this.appliedFilters.wholesalerIds[0])),
                ];
                return wholesaler != null ? wholesaler : [];
            },

            filters() {
                return this.filteredWholesaler.concat(this.filteredCategory, this.filteredBrand);
            },

            priceRangeDisplayValue() {
                const priceRange = [...this.priceRange];
                let priceRangeDisplayValue = 'All';
                if (priceRange[0] === common.minPrice && priceRange[1] === common.maxPrice) {
                    priceRangeDisplayValue = 'All';
                } else if (priceRange[0] === '0' && priceRange[1] === '5') {
                    priceRangeDisplayValue = '0-5';
                } else if (priceRange[0] === '5' && priceRange[1] === '10') {
                    priceRangeDisplayValue = '5-10';
                } else if (priceRange[0] === '10' && priceRange[1] === '20') {
                    priceRangeDisplayValue = '10-20';
                } else if (priceRange[0] === '20' && priceRange[1] === '50') {
                    priceRangeDisplayValue = '20-50';
                } else if (priceRange[0] === '50' && priceRange[1] === '100') {
                    priceRangeDisplayValue = '50-100';
                } else if (priceRange[0] === '100') {
                    priceRangeDisplayValue = 'Above 100';
                }
                return priceRangeDisplayValue;
            },
        },

        watch: {
            priceRange: {
                handler() {
                    if (this.mounted) {
                        this.debouncedFetchFilteredProductsBySelectedFilters();
                    }
                },
            },
            productFilterStatus: {
                handler() {
                    if (this.mounted) {
                        this.fetchFilteredProductsBySelectedFilters();
                    }
                },
            },
            productFilterBrandId: {
                handler() {
                    if (this.mounted) {
                        this.fetchFilteredProductsBySelectedFilters();
                    }
                },
            },
        },

        created() {
            this.mounted = false;
            if (this.sortBy) this.sortedBy = this.sortBy;
            this.currentPage = this.products.current_page;

            if (this.appliedFilters.brandIds) {
                this.productFilterBrandId = parseInt(this.appliedFilters.brandIds[0]);
            }

            if (this.appliedFilters.status) {
                this.productFilterStatus = this.appliedFilters.status;
            }

            if (this.appliedFilters.minPrice && this.appliedFilters.maxPrice) {
                this.priceRange = [this.appliedFilters.minPrice, this.appliedFilters.maxPrice];

                this.$nextTick(function () {
                    this.$refs.priceRange.value = this.priceRangeDisplayValue;
                });
            }

            if (this.appliedFilters.categoryIds) {
                const currentFilterCategoryId = this.appliedFilters.categoryIds[0];
                if (currentFilterCategoryId) {
                    const currentFilterCategory = this.categories.find(
                        (category) => parseInt(category.id) === parseInt(currentFilterCategoryId),
                    );
                    this.isFilteredByParentCategory = !currentFilterCategory.parent_id;
                }
            }

            this.debouncedFetchFilteredProductsBySelectedFilters = _.debounce(
                this.fetchFilteredProductsBySelectedFilters,
                2000,
            );
        },

        mounted() {
            setTimeout(() => {
                this.$nextTick(() => {
                    this.mounted = true;
                });
            }, 1000);
        },

        methods: {
            setPriceRange(value) {
                if (value === 'All') {
                    this.priceRange = [common.minPrice, common.maxPrice];
                } else if (value === '0-5') {
                    this.priceRange = [0, 5];
                } else if (value === '5-10') {
                    this.priceRange = [5, 10];
                } else if (value === '10-20') {
                    this.priceRange = [10, 20];
                } else if (value === '20-50') {
                    this.priceRange = [20, 50];
                } else if (value === '50-100') {
                    this.priceRange = [50, 100];
                } else {
                    this.priceRange = [100, common.maxPrice];
                }
            },

            fetchFilteredProducts(newPage) {
                if (this.$page.url.includes('/search/')) {
                    this.$inertia.get(
                        route('search.show', {
                            keyword: this.appliedFilters.keyword,
                            minPrice: this.priceRange[0],
                            maxPrice: this.priceRange[1],
                            categoryIds: this.appliedFilters.categoryIds,
                            wholesalerIds: this.appliedFilters.wholesalerIds,
                            brandIds: this.productFilterBrandId ? [this.productFilterBrandId] : null,
                            sortBy: this.sortBy,
                            page: newPage,
                        }),
                    );
                } else {
                    this.$inertia.get(
                        route('products.index', {
                            minPrice: this.priceRange[0],
                            maxPrice: this.priceRange[1],
                            categoryIds: this.appliedFilters.categoryIds,
                            wholesalerIds: this.appliedFilters.wholesalerIds,
                            brandIds: this.productFilterBrandId ? [this.productFilterBrandId] : null,
                            sortBy: this.sortBy,
                            page: newPage,
                        }),
                    );
                }
            },

            currentlyFilteredCategoryBannerPath() {
                if (this.appliedFilters.categoryIds) {
                    return this.categories.find(
                        (category) => parseInt(category.id) === parseInt(this.appliedFilters.categoryIds[0]),
                    );
                }
                return null;
            },

            fetchFilteredProductsByCategory(categoryId) {
                if (this.$page.url.includes('/search/')) {
                    this.$inertia.get(
                        route('search.show', {
                            keyword: this.appliedFilters.keyword,
                            minPrice: this.priceRange[0],
                            maxPrice: this.priceRange[1],
                            categoryIds: [categoryId],
                            wholesalerIds: this.appliedFilters.wholesalerIds,
                            brandIds: this.productFilterBrandId ? [this.productFilterBrandId] : null,
                            sortBy: this.sortBy,
                            page: this.products.current_page,
                            status: this.productFilterStatus,
                        }),
                    );
                } else {
                    this.$inertia.get(
                        route('products.index', {
                            minPrice: this.priceRange[0],
                            maxPrice: this.priceRange[1],
                            categoryIds: [categoryId],
                            wholesalerIds: this.appliedFilters.wholesalerIds,
                            brandIds: this.productFilterBrandId ? [this.productFilterBrandId] : null,
                            sortBy: this.sortBy,
                            page: this.products.current_page,
                            status: this.productFilterStatus,
                        }),
                    );
                }
            },

            fetchFilteredProductsByCategoryOnly(categoryId) {
                this.$inertia.get(route('products.index', { categoryIds: [categoryId] }));
            },

            // fetchFilteredProductsByWholesalerOnly(wholesalerId) {
            //     this.$inertia.get(route('products.index', { wholesalerIds: [wholesalerId] }));
            // },

            fetchFilteredProductsByWholesaler(wholesalerId) {
                if (this.$page.url.includes('/search/')) {
                    this.$inertia.get(
                        route('search.show', {
                            keyword: this.appliedFilters.keyword,
                            minPrice: this.priceRange[0],
                            maxPrice: this.priceRange[1],
                            categoryIds: this.appliedFilters.categoryIds,
                            wholesalerIds: [wholesalerId],
                            brandIds: this.productFilterBrandId ? [this.productFilterBrandId] : null,
                            sortBy: this.sortBy,
                            page: this.products.current_page,
                        }),
                    );
                } else {
                    this.$inertia.get(
                        route('products.index', {
                            minPrice: this.priceRange[0],
                            maxPrice: this.priceRange[1],
                            categoryIds: this.appliedFilters.categoryIds,
                            wholesalerIds: [wholesalerId],
                            brandIds: this.productFilterBrandId ? [this.productFilterBrandId] : null,
                            sortBy: this.sortBy,
                            page: this.products.current_page,
                        }),
                    );
                }
            },

            fetchFilteredProductsByBrand(brandId = null) {
                if (this.$page.url.includes('/search/')) {
                    this.$inertia.get(
                        route('search.show', {
                            keyword: this.appliedFilters.keyword,
                            minPrice: this.priceRange[0],
                            maxPrice: this.priceRange[1],
                            categoryIds: this.appliedFilters.categoryIds,
                            wholesalerIds: this.appliedFilters.wholesalerIds,
                            page: this.products.current_page,
                            status: this.productFilterStatus,
                            brandIds: [brandId],
                            sortBy: this.sortBy,
                        }),
                    );
                } else {
                    this.$inertia.get(
                        route('products.index', {
                            minPrice: this.priceRange[0],
                            maxPrice: this.priceRange[1],
                            categoryIds: this.appliedFilters.categoryIds,
                            wholesalerIds: this.appliedFilters.wholesalerIds,
                            page: this.products.current_page,
                            status: this.productFilterStatus,
                            brandIds: [brandId],
                            sortBy: this.sortBy,
                        }),
                    );
                }
            },

            getSearchResultsFor() {
                if (
                    !this.isFilteredByParentCategory ||
                    this.appliedFilters.brandIds ||
                    this.appliedFilters.wholesalerIds
                ) {
                    if (this.$page.url.includes('/search/')) {
                        this.$inertia.get(
                            route('search.show', {
                                keyword: this.search,
                                minPrice: this.priceRange[0],
                                maxPrice: this.priceRange[1],
                                categoryIds: this.appliedFilters.categoryIds,
                                wholesalerIds: this.appliedFilters.wholesalerIds,
                                page: this.products.current_page,
                                status: this.productFilterStatus,
                                brandIds: this.productFilterBrandId ? [this.productFilterBrandId] : null,
                                sortBy: this.sortBy,
                            }),
                        );
                    } else {
                        this.$inertia.get(
                            route('products.index', {
                                minPrice: this.priceRange[0],
                                maxPrice: this.priceRange[1],
                                categoryIds: this.appliedFilters.categoryIds,
                                wholesalerIds: this.appliedFilters.wholesalerIds,
                                page: this.products.current_page,
                                status: this.productFilterStatus,
                                brandIds: this.productFilterBrandId ? [this.productFilterBrandId] : null,
                                sortBy: this.sortBy,
                                keyword: this.search,
                            }),
                        );
                    }
                }
            },

            fetchFilteredProductsBySelectedFilters() {
                if (
                    !this.isFilteredByParentCategory ||
                    this.appliedFilters.brandIds ||
                    this.appliedFilters.wholesalerIds
                ) {
                    if (this.$page.url.includes('/search/')) {
                        this.$inertia.get(
                            route('search.show', {
                                keyword: this.appliedFilters.keyword,
                                minPrice: this.priceRange[0],
                                maxPrice: this.priceRange[1],
                                categoryIds: this.appliedFilters.categoryIds,
                                wholesalerIds: this.appliedFilters.wholesalerIds,
                                page: this.products.current_page,
                                status: this.productFilterStatus,
                                brandIds: this.productFilterBrandId ? [this.productFilterBrandId] : null,
                                sortBy: this.sortBy,
                            }),
                        );
                    } else {
                        this.$inertia.get(
                            route('products.index', {
                                minPrice: this.priceRange[0],
                                maxPrice: this.priceRange[1],
                                categoryIds: this.appliedFilters.categoryIds,
                                wholesalerIds: this.appliedFilters.wholesalerIds,
                                page: this.products.current_page,
                                status: this.productFilterStatus,
                                brandIds: this.productFilterBrandId ? [this.productFilterBrandId] : null,
                                sortBy: this.sortBy,
                            }),
                        );
                    }
                }
            },

            clearAll() {
                this.$inertia.get(route('products.index'));
            },

            clearTag(tag) {
                if (tag.email) {
                    this.$inertia.get(
                        route('products.index', {
                            minPrice: this.priceRange[0],
                            maxPrice: this.priceRange[1],
                            categoryIds: this.appliedFilters.categoryIds,
                            brandIds: this.productFilterBrandId ? [this.productFilterBrandId] : null,
                            sortBy: this.sortBy,
                        }),
                    );
                } else if (tag.category_id) {
                    this.$inertia.get(
                        route('products.index', {
                            minPrice: this.priceRange[0],
                            maxPrice: this.priceRange[1],
                            categoryIds: this.appliedFilters.categoryIds,
                            wholesalerIds: this.appliedFilters.wholesalerIds,
                            sortBy: this.sortBy,
                        }),
                    );
                } else {
                    this.$inertia.get(
                        route('products.index', {
                            minPrice: this.priceRange[0],
                            maxPrice: this.priceRange[1],
                            brandIds: this.productFilterBrandId ? [this.productFilterBrandId] : null,
                            wholesalerIds: this.appliedFilters.wholesalerIds,
                            sortBy: this.sortBy,
                        }),
                    );
                }
            },

            categoriesForShopByCategory() {
                const childCategories = this.categories.filter((eachCategory) => eachCategory.parent_id !== null);
                const first12 = [];
                childCategories.forEach((eachCategory, index) => {
                    if (index < 8) {
                        first12.push(eachCategory);
                    }
                });
                return first12;
            },

            brandsForShopByBrand() {
                // commented to change home view same as parent category view
                // const childBrands = this.brands.filter(
                //     (eachBrand) => parseInt(eachBrand.category_id) === parseInt(this.appliedFilters.categoryIds[0])
                // );
                const first12 = [];
                // changed foreach of childBrands to brands to change home view same as parent category view
                // childBrands.forEach((eachBrand, index) => {
                this.brands.forEach((eachBrand, index) => {
                    if (index < 8) {
                        first12.push(eachBrand);
                    }
                });
                return first12;
            },

            productsForShopByDeal() {
                const first12 = [];
                this.products.data.forEach((eachBrand, index) => {
                    if (index < 8) {
                        first12.push(eachBrand);
                    }
                });
                if (
                    !(
                        !this.isFilteredByParentCategory ||
                        this.appliedFilters.brandIds ||
                        this.appliedFilters.wholesalerIds
                    )
                ) {
                    return first12;
                }
                return [];
            },
        },
    };
</script>
